import React, { useState } from "react";
import sbox from "../assets/sbox.jpg";
import rcon from "../assets/rcon.png";

const Verify = ({
  allResults,
  setVerificationState,
  incrementRoundAndCounter,
  decrementRoundAndCounter,
}) => {
  const [inputs, setInputs] = useState(["", "", "", ""]);
  const [verificationResult, setVerificationResult] = useState("");
  let round = 4;

  const handleVerify = () => {
    if (
      inputs[0].toLowerCase().split(" ").join("") === allResults[3][12].join("") &&
      inputs[1].toLowerCase().split(" ").join("") === allResults[3][13].join("") &&
      inputs[2].toLowerCase().split(" ").join("") === allResults[3][14].join("") &&
      inputs[3].toLowerCase().split(" ").join("") === allResults[3][15].join("")
    ) {
      setVerificationResult("Verification successful! Click on Next again");
      setVerificationState(true);
      incrementRoundAndCounter();
    } else {
      setVerificationResult("Verification failed. Try again.");
    }
  };

  return (
    <>
      <div className="bg-gray-100 p-4 rounded-md shadow-md">
        <h2 className="text-2xl font-semibold mb-4">Verification of Round 3</h2>
        <p className="pb-5">
          Now calculate the Subkey Value for Round 3 and enter it below (It
          should be the hex values)
        </p>
        <div className="grid grid-cols-2 gap-4">
          <input
            type="text"
            value={inputs[0]}
            onChange={(e) =>
              setInputs((prevState) => ({ ...prevState, [0]: e.target.value }))
            }
            className="bg-white border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:border-blue-300"
            placeholder="w12"
          />
          <input
            type="text"
            value={inputs[1]}
            onChange={(e) =>
              setInputs((prevState) => ({ ...prevState, [1]: e.target.value }))
            }
            className="bg-white border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:border-blue-300"
            placeholder="w13"
          />
          <input
            type="text"
            value={inputs[2]}
            onChange={(e) =>
              setInputs((prevState) => ({ ...prevState, [2]: e.target.value }))
            }
            className="bg-white border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:border-blue-300"
            placeholder="w14"
          />
          <input
            type="text"
            value={inputs[3]}
            onChange={(e) =>
              setInputs((prevState) => ({ ...prevState, [3]: e.target.value }))
            }
            className="bg-white border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:border-blue-300"
            placeholder="w15"
          />
        </div>
        <div className="button-holder">
        <div className="prev-button" onClick={decrementRoundAndCounter}>
          PREVIOUS
        </div>
        <div className="next-button" onClick={handleVerify}>
          NEXT
        </div>
      </div>
        <p className="text-red-500 mt-2">{verificationResult}</p>
      </div>
      <div className="grid grid-cols-3 gap-8 content-center pt-4 px-4">
        <div>
          <table className="border-separate border-spacing-2 border border-slate-500 ...">
            <tr>
              <th colSpan={4}>Sub Key - {round / 4 }</th>
              <th colSpan={4}>Sub Key - {round / 4 + 1}</th>
            </tr>
            <tr>
              <th className=" bg-red-400">w{round}</th>
              <th className=" bg-red-400">w{round + 1}</th>
              <th className=" bg-red-400">w{round + 2}</th>
              <th className=" bg-red-400">w{round + 3}</th>
              <th className=" bg-green-400">w{round + 4}</th>
              <th className=" bg-green-400">w{round + 5}</th>
              <th className=" bg-green-400">w{round + 6}</th>
              <th className=" bg-green-400">w{round + 7}</th>
              <th>...</th>
              <th>...</th>
              <th>w43</th>
            </tr>

            <tr>
              <td>{allResults[3][round][0]}</td>
              <td>{allResults[3][round + 1][0]}</td>
              <td>{allResults[3][round + 2][0]}</td>
              <td>{allResults[3][round + 3][0]}</td>
              <td className=" font-bold">{allResults[3][round + 4][0]}</td>
              <td className=" font-bold">{allResults[3][round + 5][0]}</td>
              <td className=" font-bold">{allResults[3][round + 6][0]}</td>
              <td className=" font-bold">{allResults[3][round + 7][0]}</td>
            </tr>
            <tr>
              <td>{allResults[3][round][1]}</td>
              <td>{allResults[3][round + 1][1]}</td>
              <td>{allResults[3][round + 2][1]}</td>
              <td>{allResults[3][round + 3][1]}</td>
              <td className=" font-bold">{allResults[3][round + 4][1]}</td>
              <td className=" font-bold">{allResults[3][round + 5][1]}</td>
              <td className=" font-bold">{allResults[3][round + 6][1]}</td>
              <td className=" font-bold">{allResults[3][round + 7][1]}</td>
            </tr>
            <tr>
              <td>{allResults[3][round][2]}</td>
              <td>{allResults[3][round + 1][2]}</td>
              <td>{allResults[3][round + 2][2]}</td>
              <td>{allResults[3][round + 3][2]}</td>
              <td className=" font-bold">{allResults[3][round + 4][2]}</td>
              <td className=" font-bold">{allResults[3][round + 5][2]}</td>
              <td className=" font-bold">{allResults[3][round + 6][2]}</td>
              <td className=" font-bold">{allResults[3][round + 7][2]}</td>
            </tr>
            <tr>
              <td>{allResults[3][round][3]}</td>
              <td>{allResults[3][round + 1][3]}</td>
              <td>{allResults[3][round + 2][3]}</td>
              <td>{allResults[3][round + 3][3]}</td>
              <td className=" font-bold">{allResults[3][round + 4][3]}</td>
              <td className=" font-bold">{allResults[3][round + 5][3]}</td>
              <td className=" font-bold">{allResults[3][round + 6][3]}</td>
              <td className=" font-bold">{allResults[3][round + 7][3]}</td>
            </tr>
          </table>
        </div>
        <div>
          <img src={sbox} width="500" height="600" alt="sbox"></img>
        </div>
        <div>
          <img src={rcon} width="500" height="600" alt="rcon"></img>
        </div>
      </div>
    </>
  );
};

export default Verify;
